import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LogoMark from '../assets/LogoMark.png';
import '../styles/Footer.css';

function Footer() {
  const { t, i18n } = useTranslation();
  const isDutch = i18n.resolvedLanguage?.startsWith('nl');

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-content">
          <section className="footer-section footer-brand-section">
            <Link to="/" className="footer-brand">
              <span className="footer-logo-frame"><img src={LogoMark} alt="" /></span>
              <span>Main <strong>Tendue</strong></span>
            </Link>
            <p>{t('translate.footer_desc')}</p>
            <span className="footer-approval">Agrément COCOF n° 30.01.14</span>
          </section>

          <section className="footer-section">
            <h3>{t('translate.footer_liens')}</h3>
            <ul className="footer-links">
              <li><Link to="/">{t('translate.footer_acceuil')}</Link></li>
              <li><Link to="/services">{isDutch ? 'Diensten & tarieven' : 'Services & tarifs'}</Link></li>
              <li><Link to="/transport-medico-sanitaire-bruxelles">{isDutch ? 'Medisch vervoer' : 'Transport médico-sanitaire'}</Link></li>
              <li><Link to="/transport-pmr-bruxelles">{isDutch ? 'Rolstoelvervoer' : 'Transport PMR et TPMR'}</Link></li>
              <li><Link to="/transport-dialyse-bruxelles">{isDutch ? 'Dialysevervoer' : 'Transport dialyse'}</Link></li>
              <li><Link to="/remboursement-transport-medical">{isDutch ? 'Terugbetaling vervoer' : 'Remboursement du transport'}</Link></li>
              <li><Link to="/reservation">{isDutch ? 'Reserveren' : 'Réservation'}</Link></li>
              <li><Link to="/faq">{t('translate.footer_faq')}</Link></li>
              <li><Link to="/contact">{t('translate.footer_contact')}</Link></li>
            </ul>
          </section>

          <section className="footer-section">
            <h3>{t('translate.footer_title_2')}</h3>
            <address>
              <span><i className="fas fa-map-marker-alt"></i>Route de Lennik 804/126<br />1070 Bruxelles</span>
              <a href="tel:+32491333777"><i className="fas fa-phone"></i>+32 491 33 37 77</a>
              <a href="mailto:info@maintendue.be"><i className="fas fa-envelope"></i>info@maintendue.be</a>
            </address>
          </section>

          <section className="footer-section">
            <h3>{t('translate.footer_horaire')}</h3>
            <div className="footer-hours"><span>{t('translate.footer_days')}</span><span>{t('translate.footer_week')}</span></div>
            <Link className="footer-book" to="/reservation">{isDutch ? 'Een rit aanvragen' : 'Demander un transport'}<i className="fas fa-arrow-right"></i></Link>
          </section>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Main Tendue Pour Tous ASBL. {t('translate.footer_asbl')}.</p>
          <nav className="footer-legal-links" aria-label={isDutch ? 'Juridische links' : 'Liens légaux'}>
            <Link to="/transport-medico-sanitaire-bruxelles">{isDutch ? 'Medisch-sanitair vervoer in Brussel' : 'Transport médico-sanitaire à Bruxelles'}</Link>
            <Link to="/policy">{t('translate.footer_politique')}</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
